import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { colorType } from 'utils/types';

import s from './Card.module.scss';

const cx = cn.bind(s);

const Card = ({
  children, className, hasBorder, borderSize = '', color = '', ...attrs
}) => (
  <div className={cx(className, 'card', color, { hasBorder, [`border_${borderSize}`]: borderSize })} {...attrs}>
    {children}
  </div>
);

Card.propTypes = {
  hasBorder: PropTypes.bool,
  color: colorType,
  borderSize: PropTypes.oneOf(['large', '']),
};

export default Card;
